import { render, staticRenderFns } from "./SesionExpiredModal.vue?vue&type=template&id=61462ea8&"
import script from "./SesionExpiredModal.vue?vue&type=script&lang=js&"
export * from "./SesionExpiredModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports